<template>
	<div style="width: 95%;margin: 0 auto;">
		<div
			style="width: 100%;height: 30px;border-left: 3px solid red;margin-top: 25px;font-size: 24px;font-weight: 800;padding-left: 25px;">
			PPT分享
		</div>

		<div @click="cid='6'"
			style="width: 200px;height: 30px;border: 1px solid #000;text-align: center;line-height: 30px;margin-top: 10px;">
			点击添加PPT分享
		</div>


		<!-- <div style="width: 90%;margin-left: 3%;height: 40px;margin-top: 25px;box-shadow: #6e6e6e 0px 0px 10px;">
			<div
				style="width: 550px;height: 30px;font-weight: 800;text-align: center;line-height: 30px;font-size: 18px;margin-left: 20px;">
				<el-radio-group v-model="cid" @change="qbesb">
					<el-radio-button label="4">期刊</el-radio-button>
					<el-radio-button label="6">期刊添加</el-radio-button>
				</el-radio-group>
			</div>
		</div> -->

		<div style="width: 100%;min-height: 300px;margin-top: 25px;">
			<div v-show="cid=='4'" style="width: 100%;">
				<div style="height: 100px;width: 100%;border-bottom: 1px dashed #6e6e6e;" v-for="(item,index) in gjqka">
					<div style="width: 50%;height: 100px;float: left;">
						<div style="width: 70%;height: 50px;line-height: 50px;text-align: left;font-size: 20px;font-weight: 800;color: #000;float: left;overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;">
							{{item.title}}
						</div>
						<div style="width: 100%;height: 50px;line-height: 60px;float: left;text-align: left;">
							<span class="el-icon-time"></span>
							<span>发布时间：</span>{{getLocalTime(item.create_time)}}   <span style="margin-left: 20px;"></span>收益金额:<i class="iconfont icon-qianbao" style="margin-left: 5px;margin-right: 5px;"></i><span>{{item.sy_money}}</span>
						</div>
					</div>
					<div style="width: 50%;height: 100px;float: left;position: relative;text-align: center;">
						<div @click="xiugaia(item)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 20px;border: 1px solid #6e6e6e;">
							修改
						</div>
						<router-link tag="div"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 130px;border: 1px solid #6e6e6e;color: blue;"
							:to="{path: '/dkyjdetail', query: {id:item.id,title:item.title,name:'PPT'}}">
							查看
						</router-link>
						<div @click="detela(item.id,item.mid)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 20px;border: 1px solid #6e6e6e;">
							删除
						</div>
					</div>
				</div>
				<!-- 分页 -->
				<div style="height: 40px;text-align: center;margin-top: 55px;">
					<el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
						:page-size="PageSize" layout="total, prev, pager, next" :total="Totals">
					</el-pagination>
				</div>
			</div>

			<!-- 国际期刊 -->
			<div v-show="cid=='6'" style="width: 90%;margin-left: 3%;min-height: 300px;margin-top: 25px;">
				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						标题:
					</div>
					<el-input v-model="form.title" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						价格:
					</div>
					<el-input v-model="form.money" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						封面:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;float: left;margin-top: 10px;"
						action="https://admin.shipoe360.com/api/picture/upload_pic" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccessssq" :limit="1"
						:on-exceed="handleExceed" :file-list="fileListssqs">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>

				<div style="width: 100%;height: 50px;margin-top: 25px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						免费的PPT:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;float: left;margin-top: 10px;"
						action="https://admin.shipoe360.com/api/picture/upload_pdf" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccessssqs" :limit="1"
						:on-exceed="handleExceed" :file-list="fileListssq">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>

				<div style="width: 100%;height: 50px;margin-top: 25px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						付费的PPT:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;float: left;margin-top: 10px;"
						action="https://admin.shipoe360.com/api/picture/upload_pdf" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccessssqss"
						:limit="1" :on-exceed="handleExceed" :file-list="fileListssqss">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>

				<div style="width: 100%;height: 550px;margin-top: 25px;margin-bottom: 25px;">
					<div style="width: 40%;height: 50px;float: left;line-height: 50px;text-align: center;">
						简介 <span style="font-size: 12px;">上传图片大小控制再“600 x 350”之间)</span> :
					</div>
					<div style="float: left;width: 90%;margin-left: 5%;height: 500px;">
						<vue-tinymce v-model="form.content" :setting="setting" />
					</div>
				</div>

				<div style="height: 50px;width: 200px;margin: 0 auto;">
					<el-button type="primary" @click="onSubmit">立即创建</el-button>
					<el-button @click="cid='4'">取消</el-button>
				</div>
			</div>


			<!-- 国内期刊 -->
			<div v-show="cid=='7'" style="width: 90%;margin-left: 3%;min-height: 300px;margin-top: 25px;">
				国内期刊
			</div>

		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				list: [],
				currentPage: 1, //当前页
				PageSize: 20, //当前每页数据
				Totals: 100, //总数据条数
				cid: '4',
				gjqka: '',
				isShow: false,
				options: [{
					value: '国内期刊',
					label: '国内期刊'
				}, {
					value: '国外期刊',
					label: '国外期刊'
				}],
				optionssss: [{
						value: '2033',
						label: '2033',
					},
					{
						value: '2032',
						label: '2032',
					},
					{
						value: '2031',
						label: '2031',
					},
					{
						value: '2030',
						label: '2030',
					},
					{
						value: '2029',
						label: '2029',
					},
					{
						value: '2028',
						label: '2028',
					},
					{
						value: '2027',
						label: '2027',
					},
					{
						value: '2026',
						label: '2026',
					},
					{
						value: '2025',
						label: '2025',
					},
					{
						value: '2024',
						label: '2024',
					},
					{
						value: '2023',
						label: '2023',
					},
					{
						value: '2022',
						label: '2022',
					},
					{
						value: '2021',
						label: '2021',
					},
					{
						value: '2020',
						label: '2020',
					},
					{
						value: '2019',
						label: '2019',
					},
					{
						value: '2018',
						label: '2018',
					},
					{
						value: '2017',
						label: '2017',
					},
					{
						value: '2016',
						label: '2016',
					},
					{
						value: '2015',
						label: '2015',
					},
					{
						value: '2014',
						label: '2014',
					},
					{
						value: '2013',
						label: '2013',
					},
					{
						value: '2012',
						label: '2012',
					},
					{
						value: '2011',
						label: '2011',
					},
					{
						value: '2010',
						label: '2010',
					},
					{
						value: '2009',
						label: '2009',
					},
					{
						value: '2008',
						label: '2008',
					},
					{
						value: '2007',
						label: '2007',
					},
					{
						value: '2006',
						label: '2006',
					},
					{
						value: '2005',
						label: '2005',
					},
					{
						value: '2004',
						label: '2004',
					},
					{
						value: '2003',
						label: '2003',
					},
					{
						value: '2002',
						label: '2002',
					},
					{
						value: '2001',
						label: '2001',
					},
					{
						value: '2000',
						label: '2000',
					}, {
						value: '1999',
						label: '1999',
					},
					{
						value: '1998',
						label: '1998',
					},
					{
						value: '1997',
						label: '1997',
					},
				],
				optionss: [{
					value: '1',
					label: '1'
				}, {
					value: '2',
					label: '2'
				}, {
					value: '3',
					label: '3'
				}, {
					value: '4',
					label: '4'
				}, {
					value: '5',
					label: '5'
				}, {
					value: '6',
					label: '6'
				}, {
					value: '7',
					label: '7'
				}, {
					value: '8',
					label: '8'
				}, {
					value: '9',
					label: '9'
				}, {
					value: '10',
					label: '10'
				}, {
					value: '11',
					label: '11'
				}, {
					value: '12',
					label: '12'
				}, ],
				optionsss: [{
					value: '1',
					label: '1'
				}, {
					value: '2',
					label: '2'
				}, {
					value: '3',
					label: '3'
				}, {
					value: '4',
					label: '4'
				}, {
					value: '5',
					label: '5'
				}, {
					value: '6',
					label: '6'
				}, {
					value: '7',
					label: '7'
				}, {
					value: '8',
					label: '8'
				}, {
					value: '9',
					label: '9'
				}, {
					value: '10',
					label: '10'
				}, {
					value: '11',
					label: '11'
				}, {
					value: '12',
					label: '12'
				}, ],
				setting: {
					menubar: false,
					toolbar: 'code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent | \
					styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
					table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | bdmap indent2em lineheight formatpainter axupimgs ltr rtl | emoticons help | wordcount',
					toolbar_drawer: "sliding",
					quickbars_selection_toolbar: "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
					plugins: "link image media table lists fullscreen quickbars advlist autosave directionality emoticons help imagetools pagebreak preview print wordcount",
					language: 'zh_CN', //本地化设置
					height: 500,
					selector: '#textarea1',
					automatic_uploads: false,
					images_upload_url: 'https://admin.shipoe360.com/ueditorphp/controller.php',
					fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
					font_formats: '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;',
				},
				form: {
					title: '',
					content: '',
					money: '',
					ppt_one: '',
					ppt_two: '',
					picture: '',
				},
				fileListssq: [],
				fileListssqs: [],
				fileListssqss: [],
				qbe: false,
				qid: '',
			}
		},
		methods: {
			async getlist() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/picture/personl_ppt_index', {
					// uid: 1,
					uid: loginInfo.id
				})
				console.log(res)
				this.gjqka = res.data.data.list
				this.Totals = res.data.data.count
				this.PageSize = res.data.data.rows_limit
			},
			async onSubmit() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (this.qbe == true) {
					let res1 = await http.post('api/picture/ppt_edit', {
						uid: loginInfo.id,
						// uid:1,
						title: this.form.title,
						content: this.form.content,
						money: this.form.money,
						ppt_one: this.form.ppt_one,
						ppt_two: this.form.ppt_two,
						picture: this.form.picture,
						id: this.qid,
					})
					console.log(res1)
					if (res1.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '修改成功',
							type: 'success'
						});
						this.cid = '4'
						this.form.title = ''
						this.form.content = ''
						this.form.money = ''
						this.form.ppt_one = ''
						this.form.ppt_two = ''
						this.form.picture = ''
						this.fileListssq = []
						this.fileListssqs = []
						this.fileListssqss = []
						this.getlist()
					}
				} else if (this.qbe == false) {
					let res = await http.post('api/picture/ppt_add', {
						uid: loginInfo.id,
						// uid:1,
						title: this.form.title,
						content: this.form.content,
						money: this.form.money,
						ppt_one: this.form.ppt_one,
						ppt_two: this.form.ppt_two,
						picture: this.form.picture,
					})
					console.log(res)
					if (res.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '添加成功',
							type: 'success'
						});
						this.form.title = ''
						this.form.content = ''
						this.form.money = ''
						this.form.ppt_one = ''
						this.form.ppt_two = ''
						this.form.picture = ''
						this.fileListssq = []
						this.fileListssqs = []
						this.fileListssqss = []
						this.getlist()
						// window.location.reload();
					}
				}
			},
			async getlists() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/picture/domestic_journals', {
					// uid: 1,
					uid: loginInfo.id
				})
				this.gjqka = res.data.data.list
				this.Totals = res.data.data.count
				this.PageSize = res.data.data.rows_limit
			},
			qbesb() {
				console.log(this.cid)
				if (this.cid == '4') {
					this.getlist();
					this.isShow = false
					this.form.title = ''
					this.form.picture = ''
					this.form.content = ''
					this.form.contry_type = ''
					this.form.eg_title = ''
					this.form.qk_pdf = ''
					this.form.qk_year = ''
					this.form.qk_number = ''
					this.form.qk_count = ''
					this.fileListssq = []
					this.fileListssqs = []
				} else if (this.cid == '5') {
					this.getlists();
					this.isShow = false
				} else if (this.cid == '6') {
					this.isShow = true
				} else if (this.cid == '7') {
					this.isShow = true
				}
			},
			xiugaia(val) {
				console.log(val)
				this.qid = val.id,
					this.form.title = val.title
				this.form.content = val.content
				this.form.money = val.money
				this.form.ppt_one = val.ppt_one
				this.form.ppt_two = val.ppt_two
				this.form.picture = val.picture
				this.cid = '6'
				this.qbe = true


				let fileArrss = [];
				let fileObjss = {};
				fileObjss.name = "图片";
				fileObjss.url = val.picture;
				fileArrss.push(fileObjss);
				this.fileListssqs = fileArrss
				let fileArrsss = [];
				let fileObjsss = {};
				fileObjsss.name = "PDF";
				fileObjsss.url = val.ppt_one;
				fileArrsss.push(fileObjsss);
				this.fileListssq = fileArrsss
				let fileArrssss = [];
				let fileObjssss = {};
				fileObjssss.name = "PDF";
				fileObjssss.url = val.ppt_two;
				fileArrssss.push(fileObjssss);
				this.fileListssqss = fileArrssss
			},
			async detela(id, mid) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/picture/ppt_delete', {
					id: id,
				})
				if (res.data.code == 200) {
					this.$notify({
						title: '成功',
						message: '删除成功',
						type: 'success'
					});
					this.getlist();
				}
			},
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
			},
			handlePreview(file) {
				console.log(file);
			},
			handsuccessssq(response, file, fileList) {
				this.form.picture = response.data.path
			},
			handsuccessssqs(response, file, fileList) {
				this.form.ppt_one = response.data.path
			},
			handsuccessssqss(response, file, fileList) {
				this.form.ppt_two = response.data.path
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			async handleCurrentChange(val) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/picture/personl_page_ppt', {
					uid: loginInfo.id,
					// uid: 1,
					page: val
				})

				this.gjqka = res.data.data.list
				this.Totals = res.data.data.count
				this.PageSize = res.data.data.rows_limit
			},
		},
		mounted() {
			this.getlist();
		}
	}
</script>

<style>
</style>
